module.exports = __webpack_public_path__ + "img/info_circle.f9767f9d.svg";